document.addEventListener('DOMContentLoaded', function () {
	initOffcanvasNavigation();
	initDropdownNavigation();
});



document.addEventListener('DOMContentLoaded', () => {
	const header = document.querySelector('header.site-header');

	if (!header) {
		return;
	}

	let previousScrollY = window.scrollY;
	let ticking = false;

	const scrollThreshold = 150;

	const updateHeaderOnScroll = () => {
		const currentScrollY = window.scrollY;
		const headerHeight = header.offsetHeight;
		const isAtTop = currentScrollY <= scrollThreshold;
		const isScrollingDown = currentScrollY > previousScrollY;

		if (isAtTop) {
			header.classList.remove('is-scrolled');
			header.style.removeProperty('top');
		} else {
			header.classList.add('is-scrolled');
		}

		previousScrollY = currentScrollY;
		ticking = false;
	};

	window.addEventListener(
		'scroll',
		() => {
			if (!ticking) {
				window.requestAnimationFrame(updateHeaderOnScroll);
				ticking = true;
			}
		},
		{ passive: true }
	);

	updateHeaderOnScroll();
});



function initOffcanvasNavigation() {
	const body = document.body;
	const toggleButton = document.getElementById('mobile-menu-toggle');
	const closeButton = document.getElementById('mobile-menu-close');
	const offcanvas = document.getElementById('mobile-offcanvas');
	const overlay = document.getElementById('mobile-menu-overlay');

	if (!toggleButton || !closeButton || !offcanvas || !overlay) {
		return;
	}

	const focusableSelectors = [
		'a[href]',
		'button:not([disabled])',
		'input:not([disabled])',
		'select:not([disabled])',
		'textarea:not([disabled])',
		'[tabindex]:not([tabindex="-1"])'
	].join(',');

	let lastFocusedElement = null;

	function getFocusableElements() {
		return offcanvas.querySelectorAll(focusableSelectors);
	}

	function openMenu() {
		lastFocusedElement = document.activeElement;

		offcanvas.classList.remove('translate-x-full');
		offcanvas.classList.add('translate-x-0');

		overlay.hidden = false;
		overlay.classList.remove('hidden');

		offcanvas.setAttribute('aria-hidden', 'false');
		toggleButton.setAttribute('aria-expanded', 'true');
		closeButton.setAttribute('aria-expanded', 'true');
		body.classList.add('overflow-hidden');

		const focusable = getFocusableElements();

		if (focusable.length) {
			focusable[0].focus();
		}
	}

	function closeMenu() {
		offcanvas.classList.remove('translate-x-0');
		offcanvas.classList.add('translate-x-full');

		overlay.classList.add('hidden');
		overlay.hidden = true;

		offcanvas.setAttribute('aria-hidden', 'true');
		toggleButton.setAttribute('aria-expanded', 'false');
		closeButton.setAttribute('aria-expanded', 'false');
		body.classList.remove('overflow-hidden');

		if (lastFocusedElement) {
			lastFocusedElement.focus();
		}
	}

	function trapFocus(event) {
		if (offcanvas.getAttribute('aria-hidden') === 'true' || event.key !== 'Tab') {
			return;
		}

		const focusable = Array.from(getFocusableElements());

		if (!focusable.length) {
			return;
		}

		const first = focusable[0];
		const last = focusable[focusable.length - 1];

		if (event.shiftKey && document.activeElement === first) {
			event.preventDefault();
			last.focus();
		} else if (!event.shiftKey && document.activeElement === last) {
			event.preventDefault();
			first.focus();
		}
	}

	toggleButton.addEventListener('click', openMenu);
	closeButton.addEventListener('click', closeMenu);
	overlay.addEventListener('click', closeMenu);

	document.addEventListener('keydown', function (event) {
		if (event.key === 'Escape' && offcanvas.getAttribute('aria-hidden') === 'false') {
			closeMenu();
		}

		trapFocus(event);
	});

	window.addEventListener('resize', function () {
		if (window.innerWidth > 991 && offcanvas.getAttribute('aria-hidden') === 'false') {
			closeMenu();
		}
	});
}

function initDropdownNavigation() {
	const menus = document.querySelectorAll('.hst-menu');

	if (!menus.length) {
		return;
	}

	menus.forEach(function (menu) {
		const isMobileMenu = menu.classList.contains('hst-menu--mobile');
		const parentItems = menu.querySelectorAll('.menu-item-has-children');

		parentItems.forEach(function (item, index) {
			const link = item.querySelector(':scope > a');
			const subMenu = item.querySelector(':scope > .sub-menu');

			if (!link || !subMenu) {
				return;
			}

			const submenuId = subMenu.id || 'hst-submenu-' + index + '-' + Math.random().toString(36).slice(2, 8);
			subMenu.id = submenuId;
			subMenu.setAttribute('aria-hidden', 'true');

			if (isMobileMenu) {
				subMenu.style.maxHeight = '0px';
			}

			const toggleButton = createToggleButton(link.textContent.trim(), submenuId, isMobileMenu);
			link.insertAdjacentElement('afterend', toggleButton);

			if (isMobileMenu) {
				setupMobileSubmenu(item, link, subMenu, toggleButton);
			} else {
				setupDesktopSubmenu(item, link, subMenu, toggleButton, menu);
			}
		});
	});

	document.addEventListener('click', function (event) {
		const desktopMenus = document.querySelectorAll('.hst-menu:not(.hst-menu--mobile)');

		desktopMenus.forEach(function (menu) {
			if (menu.contains(event.target)) {
				return;
			}

			closeAllDesktopSubmenus(menu);
		});
	});

	document.addEventListener('keydown', function (event) {
		if (event.key !== 'Escape') {
			return;
		}

		document.querySelectorAll('.hst-menu:not(.hst-menu--mobile)').forEach(function (menu) {
			closeAllDesktopSubmenus(menu);
		});
	});
}

function createToggleButton(label, submenuId, isMobileMenu) {
	const button = document.createElement('button');

	button.type = 'button';
	button.className = isMobileMenu
		? 'hst-submenu-toggle absolute right-2 top-3 z-20 inline-flex h-10 w-10 items-center justify-center rounded-md transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--hst-primary-color)] focus-visible:ring-offset-2 focus-visible:ring-offset-white'
		: 'hst-submenu-toggle absolute right-1 top-1/2 z-10 inline-flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-md transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--hst-primary-color)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--hst-header-bg)]';

	button.setAttribute('aria-expanded', 'false');
	button.setAttribute('aria-controls', submenuId);
	button.setAttribute('aria-label', 'Apri sottomenu: ' + label);
	button.dataset.openLabel = 'Apri sottomenu: ' + label;
	button.dataset.closeLabel = 'Chiudi sottomenu: ' + label;

	button.innerHTML = `
		<svg class="pointer-events-none h-4 w-4 transition-transform duration-200" viewBox="0 0 24 24" fill="none" aria-hidden="true">
			<path d="m6 9 6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
		</svg>
	`;

	return button;
}

function setupDesktopSubmenu(item, link, subMenu, toggleButton, menu) {
	function handleToggle(event) {
		event.preventDefault();
		event.stopPropagation();

		const isOpen = item.classList.contains('is-open');

		closeAllDesktopSubmenus(menu, item);

		if (!isOpen) {
			openSubmenu(item, subMenu, toggleButton, false);
		} else {
			closeSubmenu(item, subMenu, toggleButton, false);
		}
	}

	toggleButton.addEventListener('click', handleToggle);
	link.addEventListener('click', handleToggle);

	item.addEventListener('keydown', function (event) {
		if (event.key !== 'Escape') {
			return;
		}

		closeSubmenu(item, subMenu, toggleButton, false);
		link.focus();
	});
}

function setupMobileSubmenu(item, link, subMenu, toggleButton) {
	function handleToggle(event) {
		event.preventDefault();

		const isOpen = item.classList.contains('is-open');

		if (isOpen) {
			closeSubmenu(item, subMenu, toggleButton, true);
		} else {
			closeSiblingMobileSubmenus(item);
			openSubmenu(item, subMenu, toggleButton, true);
		}
	}

	toggleButton.addEventListener('click', handleToggle);
	link.addEventListener('click', handleToggle);
}

function openSubmenu(item, subMenu, toggleButton, isMobileMenu) {
	item.classList.add('is-open');

	toggleButton.setAttribute('aria-expanded', 'true');
	toggleButton.setAttribute('aria-label', toggleButton.dataset.closeLabel);
	subMenu.setAttribute('aria-hidden', 'false');

	const icon = toggleButton.querySelector('svg');
	if (icon) {
		icon.classList.add('rotate-180');
	}

	if (isMobileMenu) {
		subMenu.classList.remove('opacity-0', 'invisible', 'pointer-events-none', 'max-h-0');
		subMenu.classList.add('opacity-100', 'visible', 'pointer-events-auto');
		subMenu.style.maxHeight = subMenu.scrollHeight + 'px';
		updateParentSubmenuHeights(item);
	} else {
		subMenu.classList.remove('invisible', 'pointer-events-none', 'opacity-0', 'translate-y-2');
		subMenu.classList.add('visible', 'pointer-events-auto', 'opacity-100', 'translate-y-0');
	}
}

function closeSubmenu(item, subMenu, toggleButton, isMobileMenu) {
	item.classList.remove('is-open');

	toggleButton.setAttribute('aria-expanded', 'false');
	toggleButton.setAttribute('aria-label', toggleButton.dataset.openLabel);
	subMenu.setAttribute('aria-hidden', 'true');

	const icon = toggleButton.querySelector('svg');
	if (icon) {
		icon.classList.remove('rotate-180');
	}

	if (isMobileMenu) {
		closeNestedMobileSubmenus(item);
		subMenu.classList.remove('opacity-100', 'visible', 'pointer-events-auto');
		subMenu.classList.add('opacity-0', 'invisible', 'pointer-events-none', 'max-h-0');
		subMenu.style.maxHeight = '0px';
		updateParentSubmenuHeights(item);
	} else {
		subMenu.classList.remove('visible', 'pointer-events-auto', 'opacity-100', 'translate-y-0');
		subMenu.classList.add('invisible', 'pointer-events-none', 'opacity-0', 'translate-y-2');
	}
}

function closeAllDesktopSubmenus(menu, excludedItem = null) {
	const openItems = menu.querySelectorAll('.menu-item-has-children.is-open');

	openItems.forEach(function (item) {
		if (excludedItem && item === excludedItem) {
			return;
		}

		const subMenu = item.querySelector(':scope > .sub-menu');
		const toggleButton = item.querySelector(':scope > .hst-submenu-toggle');

		if (!subMenu || !toggleButton) {
			return;
		}

		closeSubmenu(item, subMenu, toggleButton, false);
	});
}

function closeSiblingMobileSubmenus(currentItem) {
	const parentList = currentItem.parentElement;

	if (!parentList) {
		return;
	}

	const siblingItems = parentList.querySelectorAll(':scope > .menu-item-has-children.is-open');

	siblingItems.forEach(function (item) {
		if (item === currentItem) {
			return;
		}

		const subMenu = item.querySelector(':scope > .sub-menu');
		const toggleButton = item.querySelector(':scope > .hst-submenu-toggle');

		if (!subMenu || !toggleButton) {
			return;
		}

		closeSubmenu(item, subMenu, toggleButton, true);
	});
}

function closeNestedMobileSubmenus(parentItem) {
	const nestedOpenItems = parentItem.querySelectorAll('.menu-item-has-children.is-open');

	nestedOpenItems.forEach(function (item) {
		const subMenu = item.querySelector(':scope > .sub-menu');
		const toggleButton = item.querySelector(':scope > .hst-submenu-toggle');

		if (!subMenu || !toggleButton) {
			return;
		}

		item.classList.remove('is-open');
		toggleButton.setAttribute('aria-expanded', 'false');
		toggleButton.setAttribute('aria-label', toggleButton.dataset.openLabel);
		subMenu.setAttribute('aria-hidden', 'true');
		subMenu.classList.remove('opacity-100', 'visible', 'pointer-events-auto');
		subMenu.classList.add('opacity-0', 'invisible', 'pointer-events-none', 'max-h-0');
		subMenu.style.maxHeight = '0px';

		const icon = toggleButton.querySelector('svg');
		if (icon) {
			icon.classList.remove('rotate-180');
		}
	});
}

function updateParentSubmenuHeights(item) {
	let parentMenuItem = item.parentElement ? item.parentElement.closest('.menu-item-has-children.is-open') : null;

	while (parentMenuItem) {
		const parentSubMenu = parentMenuItem.querySelector(':scope > .sub-menu');

		if (parentSubMenu) {
			parentSubMenu.style.maxHeight = parentSubMenu.scrollHeight + 'px';
		}

		parentMenuItem = parentMenuItem.parentElement
			? parentMenuItem.parentElement.closest('.menu-item-has-children.is-open')
			: null;
	}
}